module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sidebar",
    class: _vm.classes
  }, [(_vm.to) ? _c('router-link', {
    staticClass: "sidebar__link",
    attrs: {
      "to": _vm.to
    }
  }, [_c('span', {
    staticClass: "sidebar__label"
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e(), _vm._v(" "), (_vm.left) ? _c('div', {
    staticClass: "sidebar__social"
  }, [_c('h6', [_vm._v(_vm._s(_vm.social.label))]), _vm._v(" "), _c('ul', _vm._l((_vm.social.accounts), function(account) {
    return _c('li', {
      staticClass: "sidebar__account"
    }, [_c('a', {
      attrs: {
        "href": account.url,
        "target": "_blank"
      }
    }, [_c('icon', {
      attrs: {
        "id": account.icon
      }
    })], 1)])
  }))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e09d580!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/SideBar.vue
// module id = 646
// module chunks = 1